import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type TableProps = ComponentProps<'table'> & {
    containerClassName?: string
}

export const Table: FC<TableProps> = ({ className, containerClassName, ...props }): ReactNode => {
    return (
        <div className={cn('relative w-full overflow-x-auto', containerClassName)}>
            <table className={cn('w-full border-collapse text-left text-sm', className)} {...props} />
        </div>
    )
}

export const THead: FC<ComponentProps<'thead'>> = ({ className, ...props }): ReactNode => {
    return (
        <thead
            className={cn('bg-muted/55 text-[11px] font-semibold tracking-[0.06em] text-muted-foreground uppercase [&_tr]:border-b', className)}
            {...props}
        />
    )
}

export const TBody: FC<ComponentProps<'tbody'>> = ({ className, ...props }): ReactNode => {
    return <tbody className={cn('[&>tr:last-child]:border-0', className)} {...props} />
}

export const TR: FC<ComponentProps<'tr'>> = ({ className, ...props }): ReactNode => {
    return <tr className={cn('border-b border-border/80 transition-colors hover:bg-muted/35', className)} {...props} />
}

export const TH: FC<ComponentProps<'th'>> = ({ className, scope = 'col', ...props }): ReactNode => {
    return (
        <th
            scope={scope}
            className={cn('h-10 px-4 font-semibold whitespace-nowrap first:pl-5 last:pr-5', className)}
            {...props}
        />
    )
}

export const TD: FC<ComponentProps<'td'>> = ({ className, ...props }): ReactNode => {
    return <td className={cn('px-4 py-3 align-middle first:pl-5 last:pr-5', className)} {...props} />
}
